import { FC, memo } from 'react';
import { Button, ButtonProps } from 'antd';
import styled from 'styled-components';
import { Tooltip } from '../../components';
import { colorTableOperationIcon } from '@atlas-frontend/design-tokens';

export const TableOperationButton: FC<ButtonProps> = memo((props) => {
  const { title, size, ...rest } = props;
  return (
    <Tooltip title={title} placement="left">
      <StyledButton
        type="text"
        size="small"
        shape="circle"
        aria-label={title}
        {...rest}
      />
    </Tooltip>
  );
});

const StyledButton = styled(Button)`
  margin-block: -1px;
  vertical-align: top;
  color: ${colorTableOperationIcon};
`;
